import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ArchiveReportFilter from "components/pages/archivedReports/filters/ArchiveReportFilter";

import ArchivedReportTable from "components/pages/archivedReports/table/ArchivedReportTable";
import ReportDetailModal from "components/pages/transmissions/modal/detail/ReportDetailModal";

import { setTitle } from "app/store/transmission/slice/transmissionSlice";
import { useGetArchiveReportListQuery } from "app/store/archiveReport/api/archiveReportApi";
import useArchiveReports from "./useArchiveReports";
import useArchiveReportFilter from "components/pages/archivedReports/filters/useArchiveReportFilter";

const ArchivedReports = () => {
  const {
    dispatch,
    fetchTableData,
    sorting,
    pagination,
    search,
    setPagination,
    setSorting,
  } = useArchiveReports();
  const { isReportDetailModal } = useSelector((state) => state.transmission);

  const {
    filter,
    regexPattern,
    isDownloading,
    isDownloadingBulkReports,
    onSubmit,
    onInputChange,
    downloadReports,
    clearFilter,
  } = useArchiveReportFilter();

  useEffect(() => {
    dispatch(
      setTitle({
        title: "Archived Reports",
      })
    );
  }, [dispatch]);

  const { isLoading, data } = useGetArchiveReportListQuery(
    {
      page: pagination?.pageIndex,
      pageSize: pagination?.pageSize,
      search,
      sorting,
      isFetch: fetchTableData,
    },
    { refetchOnMountOrArgChange: true }
  );

  return (
    <>
      <ArchiveReportFilter
        filter={filter}
        regexPattern={regexPattern}
        onSubmit={onSubmit}
        onInputChange={onInputChange}
        clearFilter={clearFilter}
      />

      <ArchivedReportTable
        data={data}
        isLoading={isLoading}
        pagination={pagination}
        setPagination={setPagination}
        sorting={sorting}
        setSorting={setSorting}
        reports={data?.data || []}
        downloadReports={downloadReports}
        isDownloading={isDownloading}
        isDownloadingBulkReports={isDownloadingBulkReports}
      />
      {isReportDetailModal && <ReportDetailModal />}
    </>
  );
};

export default ArchivedReports;
